import { load } from 'cheerio';
import IImage from '@/interfaces/IImage';
import UrlTypes from '@/enums/UrlTypes';

/**
 * Extracts all images (src + alt) from an HTML block and returns raw IImage entries.
 * Does not normalize URLs.
 * @param html - The HTML block to extract images from.
 * @param parentPathname - The pathname of the parent page (for IImage.parentPathname).
 * @param type - The type of the parent page (for IImage.type).
 * @returns An array of IImage objects with raw src values.
 */
export function extractImagesFromHtml(
    html: string,
    parentPathname: string,
    type: UrlTypes
): IImage[] {
    const $ = load(html);
    const images: IImage[] = [];

    // Extract <img> tags
    $('img').each((_, el) => {
        const rawSrc = $(el).attr('src')?.trim() || '';
        const alt = $(el).attr('alt')?.trim() || '';
        if (rawSrc) {
            images.push({ parentPathname, src: rawSrc, alt, type });
        }
    });

    // Extract background images from inline styles
    $('[style]').each((_, el) => {
        const style = $(el).attr('style') || '';
        const match = style.match(/url\(["']?(.*?)["']?\)/);
        if (match && match[1].trim()) {
            images.push({ parentPathname, src: match[1].trim(), alt: '', type });
        }
    });

    return images;
}

